import * as React from "react";

function SvgSlant1InvertedShadow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" filter="url(#slant-1-inverted-shadow_svg__a)" enableBackground="new 0 0 1600 200" {...props}><filter id="slant-1-inverted-shadow_svg__a"><feGaussianBlur in="SourceAlpha" stdDeviation={4} /><feComponentTransfer><feFuncA type="linear" slope={0.4} /></feComponentTransfer><feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge></filter><path d="M-10 .5v10l1620 183.4v-10z" /></svg>;
}

export default SvgSlant1InvertedShadow;